import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/GlobalContext";
import { ProgressBar } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { TiPlus } from "react-icons/ti";
import kategori from "../../kategori.json";

const AddProductPage = () => {
  const [showModal, setShow] = useState(false);
  const [arrayField, setArrayField] = useState();
  const [fieldInput, setFieldInput] = useState("");
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { inputProduct, setInputProduct, progress, preview } = contextState;
  const { handleChangeInputProduk, onImageChange, handleSubmitProduk } =
    contextFunctions;
  const renderFieldName = (str) => {
    var i,
      frags = str.split("_");
    for (i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(" ");
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleChangeField = (event) => {
    let value = event.target.value;

    setFieldInput(value.split(" ").join("_").toLowerCase());
  };

  const submitField = (event) => {
    event.preventDefault();
    axios
      .post(`https://productspec.cyclic.app/form_field/`, {
        field: fieldInput,
      })
      .then((res) => {
        const tempObj = {};
        tempObj[fieldInput] = "";
        setInputProduct({ ...inputProduct, ...tempObj });
        setFieldInput("");
        setShow(false);
      });
  };

  const renderForm = (key, value) => {
    if (key == "jenis_produk") {
      return (
        <div className=" col-md-4 input-form" key={key}>
          <label htmlFor="jenis_produk" className="form-label">
            Jenis Produk
          </label>
          <select
            name="jenis_produk"
            onChange={handleChangeInputProduk}
            className="form-select"
            defaultValue={value}
            value={value}
          >
            {kategori.map((e, key) => {
              return (
                <option key={key} value={e}>
                  {e}
                </option>
              );
            })}
          </select>
        </div>
      );
    } else {
      return (
        <div className=" col-md-4 input-form" key={key}>
          <label htmlFor={key} className="form-label">
            {renderFieldName(key)}
          </label>
          <input
            type="text"
            className="form-control"
            id={key}
            onChange={handleChangeInputProduk}
            value={value}
            name={key}
            placeholder={key.replace(/_/g, " ")}
          />
        </div>
      );
    }
  };

  useEffect(() => {
    axios.get(`https://productspec.cyclic.app/form_field/`).then((response) => {
      setArrayField(response.data);
    });
  }, []);

  useEffect(() => {
    setInputProduct({
      nama_produk: "",
      dimensi: "",
      bahan: "",
      jenis_produk: "appliances",
      fitur: "",
      daya: "",
    });
    if (arrayField !== undefined) {
      const tempObj = {};
      arrayField.forEach((el) => {
        tempObj[el.field] = "";
      });
      setInputProduct({ ...inputProduct, ...tempObj });
    }
  }, [arrayField]);

  return (
    <div className="home page-add container-fluid">
      <div className="container">
        <h2 className="text-center fw-bold"> Input Data Produk</h2>
        <div className="btn-modal-add  mb-3 mt-3">
          <button className="btn-open-modal" onClick={handleShow}>
            <span className="icon-open-modal">
              <TiPlus />
            </span>
            Tambah Field Inputan
          </button>
        </div>

        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Tambah Field Inputan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container">
              <form onSubmit={submitField}>
                <div className="">
                  <label htmlFor="field" className="form-label">
                    Input Field
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="field"
                    onChange={handleChangeField}
                    value={fieldInput}
                    name="field"
                    placeholder="field..."
                  />
                </div>
                <div className="bg-light mt-3 text-center">
                  <button type="submit" className="btn btn-primary pull-right">
                    Tambah
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="nostyle-btn btn-close-modal"
              onClick={handleClose}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <form
          onSubmit={handleSubmitProduk}
          className="row g-3 mt-3 form-border"
        >
          {inputProduct !== undefined ? (
            Object.entries(inputProduct).map(([key, value]) =>
              renderForm(key, value)
            )
          ) : (
            <p>null</p>
          )}

          <div className=" col-md-4">
            <label htmlFor="image" className="form-label">
              Foto Produk
            </label>
            <input
              type="file"
              multiple
              className="form-control"
              id="image"
              onChange={onImageChange}
              value={inputProduct.image}
              name="image"
              placeholder="Foto..."
            />
          </div>

          {progress && <ProgressBar now={progress} label={`${progress}%`} />}

          {preview ? (
            <div className="container mt-5 img-preview">
              <h3 className="text-center mb-3">Image Preview</h3>
              <figure className="image-figure row ">
                {preview.map((img, i) => {
                  return (
                    <img
                      className="image-preview col-md-6"
                      src={img}
                      alt={"image-" + i}
                      key={i}
                    />
                  );
                })}
              </figure>
            </div>
          ) : (
            ""
          )}
          <button
            type="submit"
            className="ButtonForm btn btn-primary mt-4 fw-semibold rounded-pill"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProductPage;
